import { createAction } from "typesafe-actions";

import type { CompanyAnalysisCompetititorItem } from "app/pages/sales-intelligence/modules/company-analysis/types/competitors";

export const tableRowsSelectionToggledAction = createAction(
    "@@si/company-analysis/competitors-rows-selection-toggled",
)<boolean>();

export const setSelectedRowsAction = createAction("@@si/company-analysis/competitors-set-selected-rows")<
    ReadonlyArray<CompanyAnalysisCompetititorItem & { key: React.Key }>
>();

export const setFilteredRowsAction = createAction("@@si/company-analysis/competitors-set-filtered-rows")<
    ReadonlyArray<CompanyAnalysisCompetititorItem>
>();
